import React, { createContext, useContext, useState } from 'react';
import { ToastContainer, useToast } from '../pages/Shared/ToastNotification';

const ToastContext = createContext();

export const useToastContext = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToastContext must be used within a ToastProvider');
    }
    return context;
};

export const ToastProvider = ({ children }) => {
    const toast = useToast();

    return (
        <ToastContext.Provider value={toast}>
            {children}
            <toast.ToastContainer />
        </ToastContext.Provider>
    );
};